export default __webpack_public_path__ + "static/icon-giftbox-blue-c7fe1d592b40fd20854a4e093eab7ee8.svg";